import { useProductCategories } from '../useProductCategories';
import { ProductCache } from '../../ProductCache';

function useProductCategoriesAll() {
  return useProductCategories({ cacheKey: ProductCache.categoriesCacheKey() });
}

export default useProductCategoriesAll;
